module.exports = __webpack_public_path__ + "assets/img/user-9.4506eaeb.jpg";